const listDefaultPageActions = [
    {
        title: 'Add New',
        to: '/voucher-type',
    },
];

export const listPageActions = (displayType, anyDisabled) => {
    switch (displayType) {
        case 'disabled':
            return [
                {
                    title: 'Show Active',
                    to: '/vouchers',
                },
                ...listDefaultPageActions,
            ];
        case 'active':
        default:
            if (anyDisabled) {
                return [
                    {
                        title: 'Show Disabled',
                        to: '/vouchers/disabled',
                    },
                    ...listDefaultPageActions,
                ];
            } else {
                return listDefaultPageActions;
            }
    }
};

export const editPageActions = [
    {
        title: 'Back',
        to: '/vouchers',
    },
];
